<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="月份：" prop="month">
                <span>{{model.month}}</span>
            </el-form-item>
            <el-form-item label="数据ID：" prop="data_id">
                <span>{{model.data_id}}</span>
            </el-form-item>
            <el-form-item label="报告类型：" prop="report_type">
                <span>{{model.report_type}}</span>
            </el-form-item>
            <el-form-item label="时间显示：" prop="show_time">
                <span>{{model.show_time}}</span>
            </el-form-item>
            <el-form-item label="显示用时：" prop="show_duration">
                <span>{{model.show_duration}}</span>
            </el-form-item>
            <el-form-item label="充入电量：" prop="charge_in">
                <span>{{model.charge_in}}</span>
            </el-form-item>
            <el-form-item label="费用：" prop="fee">
                <span>{{model.fee}}</span>
            </el-form-item>
            <el-form-item label="本次里程：" prop="mileage">
                <span>{{model.mileage}}</span>
            </el-form-item>
            <el-form-item label="开始剩余里程：" prop="begin_mileage">
                <span>{{model.begin_mileage}}</span>
            </el-form-item>
            <el-form-item label="结束剩余里程：" prop="end_mileage">
                <span>{{model.end_mileage}}</span>
            </el-form-item>
            <el-form-item label="起始电量：" prop="begin_soc">
                <span>{{model.begin_soc}}</span>
            </el-form-item>
            <el-form-item label="结束电量：" prop="end_soc">
                <span>{{model.end_soc}}</span>
            </el-form-item>
            <el-form-item label="平均速度：" prop="avg_speed">
                <span>{{model.avg_speed}}</span>
            </el-form-item>
            <el-form-item label="平均功率：" prop="avg_power">
                <span>{{model.avg_power}}</span>
            </el-form-item>
            <el-form-item label="平均能耗：" prop="avg_enc">
                <span>{{model.avg_enc}}</span>
            </el-form-item>
            <el-form-item label="平均室内温度：" prop="avg_inside_temp">
                <span>{{model.avg_inside_temp}}</span>
            </el-form-item>
            <el-form-item label="平均室外温度：" prop="avg_outside_temp">
                <span>{{model.avg_outside_temp}}</span>
            </el-form-item>
            <el-form-item label="比较提示信息：" prop="compare_msg">
                <span>{{model.compare_msg}}</span>
            </el-form-item>
            <el-form-item label="动画时长：" prop="moving_duration">
                <span>{{model.moving_duration}}</span>
            </el-form-item>
            <el-form-item label="充电方式：" prop="conn_charge_cable">
                <span>{{model.conn_charge_cable}}</span>
            </el-form-item>
            <el-form-item label="起始经度：" prop="begin_lng">
                <span>{{model.begin_lng}}</span>
            </el-form-item>
            <el-form-item label="起始纬度：" prop="begin_lat">
                <span>{{model.begin_lat}}</span>
            </el-form-item>
            <el-form-item label="结束经度：" prop="end_lng">
                <span>{{model.end_lng}}</span>
            </el-form-item>
            <el-form-item label="结束纬度：" prop="end_lat">
                <span>{{model.end_lat}}</span>
            </el-form-item>
            <el-form-item label="开始地点：" prop="begin_address">
                <span>{{model.begin_address}}</span>
            </el-form-item>
            <el-form-item label="结束地点：" prop="end_address">
                <span>{{model.end_address}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'simulateLineInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                month: '',
                data_id: '',
                report_type: '',
                show_time: '',
                show_duration: '',
                charge_in: '',
                fee: '',
                mileage: '',
                begin_mileage: '',
                end_mileage: '',
                begin_soc: '',
                end_soc: '',
                avg_speed: '',
                avg_power: '',
                avg_enc: '',
                avg_inside_temp: '',
                avg_outside_temp: '',
                compare_msg: '',
                moving_duration: '',
                conn_charge_cable: '',
                begin_lng: '',
                begin_lat: '',
                end_lng: '',
                end_lat: '',
                begin_address: '',
                end_address: '',
            },
            getObj:{
                url:'/api/admin/simulateline/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>